import React, { useState } from "react";
import "../../assetss/css/App.css";
import Container from "@mui/material/Container";
import CoeAutocomplete from "../CoeAutocomplete";
import Box from "@mui/material/Box";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import "dayjs/locale/en-gb";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { ModeloGetUrl } from "../ModeloCrud";
import { Typography, Button } from "@mui/material";
import ModalInformation from "../modals/ModalInformation";
import { ReportParteDiarioPDF } from "../../reportes/ReportParteDiarioPDF";
import LoadingButton from "@mui/lab/LoadingButton";

export default function ReporteTurnosPorAgenda() {
  const [selectedClinica, setSelectedClinica] = useState(null);
  const [selectedEspecialidad, setSelectedEspecialidad] = useState(null);
  const [selectedOdontologo, setSelectedOdontologo] = useState(null);
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(false);

  const now = new Date().toISOString().slice(0, 10);
  const [fechaDesde, setFechaDesde] = useState(dayjs(now));

  const [valueTipo, setValueTipo] = useState("turnos");

  const [modalMessage, setModalMessage] = useState(null);
  const [modalInformationOpen, setModalInformationOpen] = useState(false);
  const [loadingPdf, setLoadingPdf] = useState(false);

  const handleChangeTipo = (event) => {
    setValueTipo(event.target.value);
  };

  const hideInformationModal = () => {
    setModalMessage(null);
    setModalInformationOpen(false);
  };

  async function handleClickBuscar() {
    if (
      selectedClinica === null ||
      selectedEspecialidad === null ||
      selectedOdontologo === null
    ) {
      setModalMessage("Seleccione clínica, especialidad y odontólogo.");
      setModalInformationOpen(true);
      return;
    }

    setReportData(null);
    setLoading(true);

    let result = "";
    const fecha = fechaDesde.format().slice(0, 10);

    if (valueTipo === "turnos") {
      const params =
        "fecha=" +
        fecha +
        "&centro_id=" +
        selectedClinica.id +
        "&especialidad_id=" +
        selectedEspecialidad.id +
        "&odontologo_id=" +
        selectedOdontologo.id;

      result = await ModeloGetUrl(
        "centro-odontologo-especialidad",
        null,
        "parte-diario",
        params
      );
    } else {
      const params =
        "fecha-desde=" +
        fecha +
        "&fecha-hasta=" +
        fecha +
        "&centro_id=" +
        selectedClinica.id +
        "&especialidad_id=" +
        selectedEspecialidad.id +
        "&odontologo_id=" +
        selectedOdontologo.id;

      result = await ModeloGetUrl(
        "tratamiento",
        null,
        "tratamientos-entre-fechas",
        params
      );
    }

    setLoading(false);

    if (result.error === false) {
      setReportData(result.listado);
    } else {
      alert(result.errormessage);
    }
  }

  const handleDescargarPDF = async () => {
    try {
      setLoadingPdf(true);
      const tipo =
        valueTipo === "turnos" ? "parte-diario" : "parte-diario-prestaciones";

      await ReportParteDiarioPDF({
        tipo,
        data: reportData,
      });
    } catch (e) {
      console.error("Error PDF:", e);
    } finally {
      setLoadingPdf(false);
    }
  };

  return (
    <Container maxWidth="xl">
      <Box sx={{ marginBottom: 4, marginLeft: 1 }}>
        <Typography variant="h6">Parte Diario</Typography>
      </Box>

      {/* FECHA Y TIPO */}
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          justifyContent: "start",
          marginTop: 1,
          marginBottom: 5,
          marginLeft: 1,
        }}
      >
        <LocalizationProvider
          dateAdapter={AdapterDayjs}
          adapterLocale={"en-gb"}
        >
          <DatePicker
            label="Fecha"
            value={fechaDesde}
            slotProps={{ textField: { size: "small" } }}
            onChange={(newValue) => setFechaDesde(newValue)}
            sx={{
              height: "1rem",
              width: "17.8rem",
            }}
          />
        </LocalizationProvider>

        <RadioGroup
          row
          value={valueTipo}
          onChange={handleChangeTipo}
          sx={{
            marginLeft: { xs: 0, md: 4 },
            marginTop: { xs: 6, md: 0 },
          }}
        >
          <FormControlLabel value="turnos" control={<Radio />} label="Turnos" />
          <FormControlLabel
            value="prestaciones"
            control={<Radio />}
            label="Prestaciones"
          />
        </RadioGroup>
      </Box>

      {/* AUTOCOMPLETE */}
      <Box sx={{ display: "flex", justifyContent: "start", marginBottom: 5 }}>
        <CoeAutocomplete
          selectedClinica={selectedClinica}
          selectedEspecialidad={selectedEspecialidad}
          selectedOdontologo={selectedOdontologo}
          setSelectedClinica={setSelectedClinica}
          setSelectedEspecialidad={setSelectedEspecialidad}
          setSelectedOdontologo={setSelectedOdontologo}
          handlebusqueda={handleClickBuscar}
          loading={loading}
          onlyEspecialidad={true}
        />
      </Box>

      {/* BOTÓN DESCARGAR PDF */}
      {reportData !== null && reportData.length > 0 && (
        <Box sx={{ marginLeft: 3, marginTop: 4, marginBottom: 1 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleDescargarPDF}
          >
            Descargar PDF
          </Button>
        </Box>
      )}

      {/* SIN RESULTADOS */}
      {reportData !== null && reportData.length === 0 && (
        <Typography variant="h6" sx={{ marginLeft: 2 }}>
          No se encontraron resultados.
        </Typography>
      )}

      {/* MODAL INFO */}
      <ModalInformation
        showModal={modalInformationOpen && modalMessage !== null}
        hideModal={hideInformationModal}
        message={modalMessage}
      />
    </Container>
  );
}
